module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.bdd88c5d.woff2";